// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"1c1fa5ca","488":"307650aa"}[chunkId] + ".chunk.js";
};